export enum GeneratedDocumentType {
  LISTING_REPORT_EXPORT = 'LISTING_REPORT_EXPORT',
}

export enum GeneratedDocumentStatus {
  CREATED = 'CREATED',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export type GeneratedDocument = {
  id: number;
  type: GeneratedDocumentType;
  status: GeneratedDocumentStatus;
  title: string;
  errorMessage?: string | null;
  createdAt: string;
  completedAt?: string | null;
  url?: string | null;
};
